import LoadingCircle from "reports/components/simple/LoadingCircle";
import EOSReport from "../../../../components/Reports/EOSReport";
import PciSummaryMetrics from "./PciSummaryMetrics";
import { isEmpty } from "lodash";
import MetricAndPnLBreakdowns from "../../../../components/Reports/GenericCharts/MetricAndPnLBreakdowns/MetricAndPnLBreakdowns";
import { useProcessGroupNameAndMachemetryIds } from "../../../../components/Reports/reportUtils";
import PnLChart from "../../../../components/Reports/GenericCharts/PnLChart/PnLChart";
import { getPnlTimesWithProducingLosses } from "../../../../components/Reports/GenericCharts/PnLChart/pnlChartUtils";
import useEosData from "reports/store/useEosData";
import { MetricEnum } from "reports/utils/metricTypes";
import { getUptimePercent } from "./pciEosUtils";
import { useReportConfig } from "components/DataGetter/FlightConfig/useFlightConfig";

export default function PciEos() {
  const { processGroupName, machemetryIds } =
    useProcessGroupNameAndMachemetryIds({});

  // EOS needs ge and lt url params, sample is December 9, 2020, 8AM - 4PM
  const sampleLink = `/${processGroupName}?ge=1607518800000&lt=1607547600000`;

  return (
    <>
      {machemetryIds && machemetryIds.length > 0 ? (
        <EOSReport
          machemetryIds={machemetryIds}
          sampleLink={sampleLink}
          flightTimelineLinkGroup={
            processGroupName ? processGroupName.toLowerCase() : ""
          }
          shouldShowPrint={false}
          shouldSkipSkuData={false}
        >
          <PciEosComponents {...{ processGroupName, machemetryIds }} />
        </EOSReport>
      ) : (
        <LoadingCircle
          logAfterTimeout={{
            logData: { machemetryIds },
            delay: 5 * 1000,
          }}
        />
      )}
    </>
  );
}

function PciEosComponents({ processGroupName, machemetryIds }) {
  const { data } = useEosData();
  const reportConfig = useReportConfig();
  const summaryMetricsInputList = reportConfig?.eosReportMetricsConfig
    ?.summaryMetricsInputList ?? [
    { name: MetricEnum.OEE, order: 0 },
    { name: MetricEnum.PERF, order: 1 },
    { name: MetricEnum.TAGGING, order: 3 },
    { name: MetricEnum.COUNT, order: 4 },
  ];

  return data && !isEmpty(data) && machemetryIds && machemetryIds.length > 0 ? (
    <>
      <PciSummaryMetrics {...{ data, processGroupName }} />
      <PnLChart pnlTimes={getPnlTimesWithProducingLosses({ data })} />
      <MetricAndPnLBreakdowns
        {...{
          machemetryIds,
        }}
        summaryMetricsInputList={summaryMetricsInputList}
        getCustomSummaryMetricsInputListWithPnlBreakdown={pnlBreakdown => {
          const customUptime = pnlBreakdown && getUptimePercent(pnlBreakdown);

          return [
            {
              name: MetricEnum.UPTIME,
              customValue: customUptime,
              order: 2,
            },
          ];
        }}
      />
    </>
  ) : (
    <LoadingCircle
      logAfterTimeout={{
        logData: { eosData: data, machemetryIds },
        delay: 5 * 1000,
      }}
    />
  );
}
